<div class="mobile-sort">
  <div class="d-flex justify-content-between align-items-baseline">
    <h2 class="mobile-sort__header" translate>sortResults</h2>
    <button
      (click)="onClose()"
      [attr.aria-label]="'closeDialog' | translate"
      class="close-btn p-0 m-n2"
      data-automation-id="close-sort-popup"
      type="button">
      <span aria-hidden="true" class="icon icon-close"></span>
    </button>
  </div>
  <div
    class="results-number-counter"
    data-automation-id="results-number-counter"
    translate
    [translateParams]="{
    resultsStart: resultsStart,
    resultsEnd: resultsEnd,
    calculatedTotalResults: calculatedTotalResults
    }">currentNumberOfResults
  </div>
  <search-res-sort
    [focus$]="focusSortButton$"
    (onChange)="sortChanged.emit($event); onClose()"
    [value]="sortValue">
  </search-res-sort>
  <app-search-res-number
    [focus$]="focusResultsNumberButton$"
    (onChange)="searchNumberChanged.emit($event); onClose()"
    [value]="pageSize">
  </app-search-res-number>
</div>
